





















































import 'aos/dist/aos.css';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class About extends Vue {
  public welcome: { name: string } = { name: 'WELCOME' };
  public subWelcome: { name: string } = {
    name:
      'We are Remeco Care. We believe all health care should be affordable and safe.',
  };

  public async mounted() {
    const AOS = await import('aos');
    AOS.init();
  }
}
